<template>
  <third-party-form v-if="model"
                    :data="model"
                    :title="$t('thirdParties.edit.title', { name: model ? model.name : ''})"
                    :submit-loading="submitLoading"
                    @submit="onSubmit">
  </third-party-form>
</template>
<script>
  import get from 'lodash/get'
  import ThirdPartyForm from './ThirdPartyForm'
  import ThirdPartiesService from 'src/services/ThirdPartiesService'

  export default {
    components: {
      ThirdPartyForm,
    },
    data () {
      return {
        submitLoading: false,
        model: null,
      }
    },
    methods: {
      async getData () {
        let {data} = await ThirdPartiesService.getById(this.$route.params.id)
        this.populatePrivateFields(data)
        this.populatePublicFields(data)
        this.model = data
      },
      populatePublicFields (data) {
        if (!data.public_information) {
          data.public_information = {}
        }
        const fields = get(data, 'fields.public', {})
        for (let field in fields) {
          if (data.public_information[field] === undefined) {
            data.public_information[field] = null
          }
        }
      },
      populatePrivateFields (data) {
        if (!data.private_information) {
          data.private_information = {}
        }
        const fields = get(data, 'fields.private', {})
        for (let field in fields) {
          if (data.private_information[field] === undefined) {
            data.private_information[field] = null
          }
        }
      },
      async onSubmit (data, redirect = false) {
        try {
          this.submitLoading = true
          await ThirdPartiesService.update(data.id, data)
          if (redirect) {
            this.$router.push('/settings/third-parties')
          }
        } finally {
          this.submitLoading = false
        }
      },
    },
    watch: {
      '$store.state.config.textLanguage' () {
        this.getData()
      },
    },
    async created () {
      await this.getData()
    }
  }
</script>
<style>
</style>
